import React, { JSX } from 'react';
import {
  StyledBrandContainer,
  StyledBrandName,
  StyledLogoContainer
} from './style';
import { ComposeType, StyledDiv } from '../../../Theme/CommonStyled';

type BrandContainerType = {
  logo?: string;
  children?: JSX.Element | string;
  brandName: string;
  caption?: string;
  logoStyle?: ComposeType;
  brandNameStyle?: ComposeType;
  noBackground?: boolean;
};

const BrandContainerWithLogo: React.FC<BrandContainerType> = ({
  logo,
  children,
  brandName,
  caption,
  logoStyle,
  brandNameStyle,
  noBackground = false
}) => {
  return (
    <StyledBrandContainer noBackground={noBackground}>
      <StyledLogoContainer {...logoStyle} logo={logo} />
      <StyledBrandName {...brandNameStyle}>{brandName}</StyledBrandName>
      {caption && (
        <StyledDiv
          fontSize={4}
          fontWeight={4}
          color="secondaryText"
          textAlign="center"
          mt={4}
          mb={14}>
          {caption}
        </StyledDiv>
      )}
      {children}
    </StyledBrandContainer>
  );
};

export default BrandContainerWithLogo;
